import { compose, filter, values } from 'ramda';
import { createSelector } from 'reselect';

import user from 'features/views/user';

import { byChannelId, byRegionId, restrictBy } from '../utils';
import { selectors } from './reducer';

export const getAllAgencies = selectors.getData;

export const getAgencies = createSelector(
	(_, formData) => formData?.channel,
	(_, formData) => formData?.region,
	getAllAgencies,
	user.selectors.getAllowedAgencies,
	(channelId, regionId, agencies, allowedAgencies) => {
		return compose(
			restrictBy(allowedAgencies),
			filter(byRegionId(regionId)),
			filter(byChannelId(channelId)),
			values,
		)(agencies);
	},
);

export const getAgenciesForSidebar = createSelector(
	(state, formData) => formData?.channel,
	(state, formData) => formData?.region,
	getAllAgencies,
	user.selectors.getAllowedAgencies,
	(state, formData, customAllowedAgencies) => customAllowedAgencies,
	(channelId, regionId, agencies, baseAllowedAgencies, customAllowedAgencies) => {
		return compose(
			restrictBy(customAllowedAgencies),
			restrictBy(baseAllowedAgencies),
			filter(byRegionId(regionId)),
			filter(byChannelId(channelId)),
			values,
		)(agencies);
	},
);
